// extracted by mini-css-extract-plugin
export default {"cards":"Home_cards__BKcWJ","background":"Home_background__+A9+x","pokemonscontainer":"Home_pokemonscontainer__B+RUf","refresh":"Home_refresh__ur8-I"};